import { useTypedDispatch } from "../../app/state";
import { useSelector } from "react-redux";
import { selectCurrentLocation, selectCurrentLocationId } from "../../store/locationStore/locationSelectors";
import React, { useEffect } from "react";
import { clearDeviceList } from "../../store/deviceStore/deviceState";
import { clearTemplateList } from "../../store/templatesStore/templateState";
import { getAllWirelessSystems } from "../../store/wirelessSystemStore/wirelessSystemRequests";
import { GeneralRequest } from "../../requests/GeneralRequest";
import TabsContent from "../../components/TabsContent";
import { requestAllDevicesByQuery } from "../../store/deviceStore/deviceRequests";
import DeviceList from "../Shared/DeviceList";
import { requestTemplatesByCountryId } from "../../store/templatesStore/templatesRequest";
import HorizontalPanel from "../../components/HorizontalPanel";
import TemplatesList from "../Shared/TemplatesList";
import FileListContainer from "../FileListContainer";
import LicenceList from "../LicenceList";
import { getLicenceListByLocationId } from "../../store/licenceStore/licenceRequests";

export enum LOCATION_RIGHT_PANEL_TABS {
  DEVICE,
  TEMPLATES,
  FILES,
  LICENCE,
}

const LocationRightPanelTab = () => {
  const dispatch = useTypedDispatch();
  const currentLocationId = useSelector(selectCurrentLocationId);
  const currentLocation = useSelector(selectCurrentLocation);
  const mapId = currentLocation?.mapId;
  const countryId = currentLocation?.countryId;

  useEffect(() => {
    dispatch(clearDeviceList());
  }, [ mapId ]);

  useEffect(() => {
    dispatch(clearTemplateList());
  }, [ countryId ]);

  return (
    <GeneralRequest requestAction={getAllWirelessSystems}>
      <TabsContent
        selectedId={LOCATION_RIGHT_PANEL_TABS.DEVICE}
        items={[
          {
            label: 'Devices',
            id: LOCATION_RIGHT_PANEL_TABS.DEVICE,
            children: (
              mapId ? (
                <GeneralRequest
                  key={mapId}
                  requestAction={requestAllDevicesByQuery}
                  requestArguments={[ { mapId } ]}
                >
                  <DeviceList
                    showFiltered={false}
                  />
                </GeneralRequest>
              ) : (
                <DeviceList />
              )
            )
          },
          {
            label: 'Templates',
            id: LOCATION_RIGHT_PANEL_TABS.TEMPLATES,
            children: (
              <GeneralRequest
                requestAction={requestTemplatesByCountryId}
                requestArguments={[ countryId ]}
              >
                <HorizontalPanel size={HorizontalPanel.SIZES.WHOLE_SPACE}>
                  <TemplatesList
                    countryId={countryId}
                  />
                </HorizontalPanel>
              </GeneralRequest>
            ),
          },
          {
            label: 'Files',
            id: LOCATION_RIGHT_PANEL_TABS.FILES,
            children: (
              <FileListContainer
                uploadAllowed
                locationId={currentLocationId}
              />
            )
          },
          {
            label: 'Licences',
            id: LOCATION_RIGHT_PANEL_TABS.LICENCE,
            children: (
              <GeneralRequest
                requestAction={getLicenceListByLocationId}
                requestArguments={[ currentLocationId ]}
              >
                <LicenceList currentLocationId={currentLocationId} />
              </GeneralRequest>
            )
          }
        ]}
      />
    </GeneralRequest>
  );
}

export default LocationRightPanelTab;